import { Inject } from '@angular/core';
import templateSource from './view.html';
              import { Component } from '@angular/core';

import Wiz from 'src/wiz';
let wiz = new Wiz('/wiz').app('portal.kiosk.home');
import { ChangeDetectorRef, OnDestroy, OnInit } from '@angular/core';
import { Service } from "src/libs/portal/season/service";
import { KioskContext, MeetingContext, MeetingLocation } from "src/libs/portal/kiosk/context";

@Component({
    selector: 'wiz-portal-kiosk-home',
template: templateSource || '',
    styles: [`

/* file: /mnt/data/wiz/project/main/build/src/app/portal.kiosk.home/view.scss */
:host {
  display: block;
}`],
})
export class PortalKioskHomeComponent implements OnInit, OnDestroy {
    public meetingLocation: MeetingLocation | null = null;
    public meetingContext: MeetingContext = { meetingId: '', reservationId: '', meetingTitle: '' };
    public showLocationSelector: boolean = false;
    public timeText: string = '--:--';
    public dateText: string = '';

    private clockTimer: any = null;
    private destroyed: boolean = false;

    constructor(@Inject( Service) public service: Service,@Inject( ChangeDetectorRef)  private ref: ChangeDetectorRef) { }

    public async ngOnInit() {
        await this.service.init(null as any);
        this.meetingContext = KioskContext.loadMeetingContext();

        const legacyTarget = KioskContext.legacyTarget();
        if (legacyTarget) {
            this.service.href(legacyTarget);
            return;
        }

        this.meetingLocation = KioskContext.loadMeetingLocation();
        this.showLocationSelector = !this.meetingLocation;
        this.updateClock();
        this.clockTimer = setInterval(() => this.updateClock(), 1000 * 30);
    }

    public ngOnDestroy() {
        this.destroyed = true;
        if (this.clockTimer) clearInterval(this.clockTimer);
    }

    public changeMeetingLocation() {
        this.showLocationSelector = true;
        this.render();
    }

    public onLocationChange(location: MeetingLocation) {
        this.meetingLocation = location;
        this.showLocationSelector = false;
        this.render();
    }

    public closeLocationSelector() {
        if (!this.meetingLocation) return;

        this.showLocationSelector = false;
        this.render();
    }

    private updateClock() {
        const clock = KioskContext.clockText();
        this.timeText = clock.timeText;
        this.dateText = clock.dateText;
        this.render();
    }

    private render() {
        if (this.destroyed) return;

        setTimeout(() => {
            if (this.destroyed) return;

            this.ref.detectChanges();
            if (this.service && this.service.inited) this.service.render();
        }, 0);
    }
}

export default PortalKioskHomeComponent;